import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, IconButton, Paper, Typography, useTheme } from '@mui/material';
import { FunctionComponent, PropsWithChildren } from 'react';
import { useAppDispatch } from '../../store/Hooks';
import { settingsStore, useSettingsSelector } from '../../store/SettingsStore';
import { GameBoardZIndex } from './GameBoardZIndex';

type Props = PropsWithChildren<{
	title: string;
}>;

/** Expandable panel for game screens */
export const GamePanel: FunctionComponent<Props> = (props) => {
	const theme = useTheme();
	const expanded = useSettingsSelector(settingsStore.selectors.gameControlsExpanded);
	const dispatch = useAppDispatch();

	return <Paper sx={{
		position: 'fixed',
		bottom: 16,
		left: 16,
		minWidth: '200px',
		maxWidth: '300px',
		bgcolor: 'rgba(255, 255, 255, 0.95)',
		borderRadius: '8px',
		overflow: 'hidden',
		boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
		zIndex: GameBoardZIndex.FacilitatorUI,
	}}>
		<Box sx={{
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			paddingX: 2,
			paddingY: 1,
			bgcolor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText,
		}}>
			<Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
				{props.title}
			</Typography>
			<IconButton
				aria-label={expanded ? 'Collapse game controls' : 'Show game controls'}
				size="small"
				onClick={() => dispatch(settingsStore.actions.toggleGameControlsExpanded())}
				sx={{ color: theme.palette.primary.contrastText }}
			>
				{expanded ? <ExpandMoreIcon /> : <ExpandLessIcon />}
			</IconButton>
		</Box>

		{expanded && <Box sx={{ padding: 2 }}>
			{props.children}
		</Box>}
	</Paper>;
};